import React, { useEffect, useState } from "react";
import "../Reason/addReasonView.css";
import DropDown from "../../../Components/dropDown/dropDown";
import Button from "../../../Components/commonButton/commonButton";
import Api from "../../../services/api";
import Alert from "../../../Components/alert/Alert";
import Select from "../../../Components/select/select";
import "../general.css";
import TextField from "../../../Components/textField/textField";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";

const DelReason = (props) => {
  const [reasons, setReasons] = useState([]);
  const [reasonsId, setReasonsId] = useState([]);
  const [description, setDescription] = useState("");
  const [id, setId] = useState(0);
  const [reload, setReload] = useState(false);
  const [show, setShow] = useState(false);
  const [code, setCode] = useState(null);
  const [message, setMessage] = useState("");
  const [readOnly, setReadOnly] = useState(true);
  const [notification, setNotification] = useState(false);
  const [notification_type, setNotificationType] = useState("success");
  const [notification_message, setNotificationMessage] = useState("");

  useEffect(() => {
    Api.get("/refuse-reasons/").then((resp) => {
      let arr = [];
      resp.data.forEach((element) => {
        arr.push({
          value: element.id,
          label: element.code + "- " + element.description,
        });
      });
      setReasons(arr);
      setReasonsId(resp.data);
    });
  }, []);

  const SelectedReason = (childData) => {
    let arrCodeDesc = childData;
    const { id, description, code } = reasonsId.find((v) => v.id == childData);
    setId(id);
    setDescription(description);
    setCode(code);
    setReadOnly(false);
  };

  const sendData = async (id) => {
    if (id > 0) {
      await Api.delete(`/refuse-reasons/${id}`, {
        code: code,
        description: description,
      })
        .then(() => {
          setNotification(true);
          setNotificationType("success");
          setNotificationMessage("Motivo de refugo deletado com sucesso!");
          setTimeout(()=>{
            return window.location.reload();
          },2000)
        })
        .catch((error) => {
          if (error.response) {
            setMessage(error.response.data);
            setShow(true);
          }
        });
    } else {
      setMessage("Necessário preencher todos os campos.");
      setShow(true);
      setReload(true);
    }
  };

  const changeValue = (value) => {
    setDescription(value);
  };
  const changeValueCode = (value) => {
    setCode(value);
  };
  const callbackfunction = () => {
    setShow(false);
  };

  const handleKeys = (e) => {
    if (document.getElementById("n1")) {
      let x = document.getElementById("n1");
      let vallen = x.value.length;
      if (
        (e.which != 8 && e.which != 46 && e.which != 0 && e.which < 48) ||
        e.which > 57 ||
        e.key == "."
      ) {
        e.preventDefault();
      }
    }
  };

  return (
    <div className="box">
    {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
    <div className="input_fields_alt_refuse_reason form">
    <h4>Deletar Refugo</h4>
      <div className="inputs">
      {show ? (
        <Alert
          show={show}
          message={message}
          parentCallback={() => callbackfunction}
          reload={reload}
        />
      ) : null}
      <div className="selectAltRefReason element">
        <Select
          autoSelect={true}
          label="Selecionar motivo"
          arrData={reasons}
          handleSelect={(value) => SelectedReason(value)}
        />
      </div>
      <div className="tf1AltRefReason element">
          <TextField
            title="Descrição"
            max={45}
            value={description}
            readOnly={true}
            parentCallback={(value) => changeValue(value)}
          />
      </div>
      <div className="tf2AltRefReason element">
          <TextField
            id="n1"
            title="Código"
            max={3}
            value={code}
            validationType="int"
            readOnly={true}
            parentCallback={(value) => changeValueCode(value)}
          />
        </div>
      </div>
      <div className="btnAltRefReason submitButton">
        <Button title="Deletar" parentCallback={() => sendData(id)} />
      </div>
    </div>
  </div>
  );
};

export default DelReason;
